import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import type { CardEditProps } from "./EditForms";
import { ExampleCards } from "./VoiceExampleCards";
import { LexiconCards } from "./VoiceLexiconCards";
import { RuleCards } from "./VoiceRuleCards";
import { ToneCards } from "./VoiceToneCards";
import { TraitCards } from "./VoiceTraitCards";

export { Group } from "./Group";

export function VoiceCards(props: {
  version: TovVersionResponse;
  edit: CardEditProps;
}) {
  return (
    <div class="tov-sections">
      <TraitCards version={props.version} edit={props.edit} />
      <ToneCards version={props.version} edit={props.edit} />
      <RuleCards version={props.version} edit={props.edit} />
      <LexiconCards version={props.version} edit={props.edit} />
      <ExampleCards version={props.version} edit={props.edit} />
    </div>
  );
}
